import { render } from "./upload.vue?vue&type=template&id=57278d74"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/upload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57278d74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57278d74', __exports__)) {
    api.reload('57278d74', __exports__)
  }
  
  module.hot.accept("./upload.vue?vue&type=template&id=57278d74", () => {
    api.rerender('57278d74', render)
  })

}


export default __exports__